module.exports = __webpack_public_path__ + "img/floor_f4_02.fb6bf29e.png";